import { InjectionToken } from '@angular/core';

import { AuthConfig } from '@lockton-apps/shared/interfaces';

export const AUTH_CONFIG = new InjectionToken<AuthConfig>(
  'Authentication config'
);

export const DEFAULT_AUTH_CONFIG: AuthConfig = {
  apiUrls: [''],
  redirectUrl: '',
};
